import Cookies from 'js-cookie'
export default {
	assessment:null,
	sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      minOpen: false // 小屏时菜单状态
    },
  current:0,
}



// WEBPACK FOOTER //
// ./src/core/store/state.js